export default __webpack_public_path__ + "/dist/images/image00006.64885386f958dc07603978c1570ebd12.jpg";